import React from 'react'
import FormSender from '../components/orderPage/formSender/FormSender'
import useSetTags from '../hooks/useSetTags'
import { CONFIG } from '../constants/TitleConfig'

const OrderPage = ({data}) => {
  useSetTags(CONFIG)
  return (
      <div><FormSender data={data.formControll}/></div>
  )
}

export default OrderPage